
    import I18n from 'i18nObj';
    
      import 'translations/publish_btn_module';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('publish_btn_module');
  